export const blockIconsCommunicationAddCommentNew = (
	<span className='material-symbols-outlined'>add_comment</span>
);
